<template>
  <div>
    <dialog-edit :value="value" @input="$emit('input')" :maxWidth="id && getAccess(`${config.accessName}.site`) ? '100hv' : '800px'">
      <template v-slot:title>
        <small v-if="id"> ({{ id }})</small>
        {{ id ? data.city + " " + data.address : `Новый '${config.title}'` }}
      </template>
      <v-row v-if="id && getAccess(`${config.accessName}.site`)" class="">
        <v-col cols="12" sm="6" style="overflow-y: auto; overflow-x: hidden" :style="{ height: $root.windowSize.innerHeight - 150 + 'px' }">
          <v-card-title class="pt-0"> Информация об объекте </v-card-title>
          <v-col cols="12" class="py-0 pt-1">
            <a-form-model
              :ref="'field_status_site'"
              v-model="data"
              :model="getFormModel(['status_site'], model)"
              :errors="errors"
              :config="{ dense: true, readonly: !getAccess('site.status') }"
              @validate="onChangeStatus($event)"
            />
          </v-col>
          <portal-target :name="`form-agent-object-` + id"></portal-target>
        </v-col>
        <v-col cols="12" sm="6" :style="{ height: $root.windowSize.innerHeight - 150 + 'px' }" style="overflow-y: auto; overflow-x: hidden">
          <s-props-form
            v-if="value"
            :model="{ title: 'Дополнительные данные для сайта', id, type: config.siteName }"
            :id="id"
            :type="config.siteName"
            :config="propsConfig"
            :objectData="data"
          />
        </v-col>
      </v-row>
      <v-layout v-else px-2 py-2 mt-1 row wrap>
        <portal-target :name="`form-agent-object-` + id"></portal-target>
      </v-layout>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <a-btn-save v-if="canSave" @click="submit()" class="pr-2"></a-btn-save>
        <a-btn-delete v-if="id && getAccess(`${config.accessName}.delete`)" @click="removeDialogShow = true"></a-btn-delete>
        <v-btn @click="$emit('input')">Закрыть</v-btn>
      </template>
    </dialog-edit>
    <portal :to="`form-agent-object-` + id">
      <a-form-modelCols
        v-model="data"
        class="pb-3 mx-1 pt-2"
        :model="getFormModel(fieldsF, model)"
        :values="data"
        :errors="errors"
        :config="{ dense: true, readonly, hideDetails: 'auto' }"
        @validate="
          validate($event);
          doWatch($event);
        "
      />
    </portal>
    <remove-dialog v-model="removeDialogShow" @remove="remove(api, id)" />
    <su-Data ref="suEdit" v-model="suEditShow" :api="api" :id="id" :activate="value" :dataEdit="data" @show="suEditShow = true" v-if="getAccess('suData')" />
  </div>
</template>

<script>
import { getForm, submitForm, removeEl, getAccess, genModel } from "../../components/mixings";

export default {
  mixins: [getAccess, getForm, submitForm, removeEl, genModel],
  props: {
    value: Boolean,
    typeObject: { type: String, default: "lampObjects" },
    id: Number,
    api: String,
    defaults: {
      type: Object,
      default: () => {},
    },
    initData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      m: this.$store.getters["config/get"].models.objects,
      model: [],
      removeDialogShow: false,
      suEditShow: false,
      panelPlan: null,
      fieldsF: "",
    };
  },
  computed: {
    config() {
      //console.log("config", this.m?.config);
      const res = this.m?.config?.[this.typeObject] || {};
      //console.log("config2", this.typeObject, res);
      return res;
    },

    propsConfig() {
      let res = {};
      res.readonly = !this.getAccess("site.edit");
      return res;
    },
    name() {
      if (!this.data) return "";
      return this.data.city + " " + this.data.address;
    },
    vendor: {
      get() {
        let res = this.data.data?.vendor || "";
        return res;
      },
      set(v) {
        if (!this.data.data?.vendor) this.data.data = Object.assign({}, this.data.data, { vendor: "" });

        this.data.data.vendor = v;
      },
    },
    readonly() {
      if (!this.id) return false;
      return !this.getAccess(this.config.accessName + ".edit", {
        id: this.id,
        data: this.data,
      });
    },
    canSave() {
      return this.getAccess(`${this.config.accessName}.edit`) || (this.getAccess(`${this.config.accessName}.create`) && !this.id);
    },
  },
  watch: {
    "data.ap_price_buy"() {
      this.calcPrice_m2();
    },
    "data.ap_area"() {
      this.calcPrice_m2();
    },

    value() {
      if (this.value) {
        this.updateData(this.id);
      }
    },
  },

  created() {
    if (!true) {
    }
  },
  methods: {
    doWatch(e) {
      console.log("do watch");
      if (e == this.m?.config.agentObjects?.watch) this.getModel(this.data?.[e]);
    },
    findConfig(t) {
      const config = this.m.config?.agentObjects?.config || [];
      for (let i = 0; i < config.length; i++) {
        const el = config[i];
        if (el.value.includes(t)) {
          return el;
        }
      }
      return null;
    },
    getModel(t) {
      const getFields = (f) => {
        if (Array.isArray(f)) return f.join(",");
        else return f;
      };
      let config = JSON.parse(JSON.stringify(this.config));
      //if (t || t === 0) config = JSON.parse(JSON.stringify(this.m?.config.agentObjects?.[t] || this.config));
      config = JSON.parse(JSON.stringify(this.findConfig(t) || this.config));
      this.watchModel = config?.watch || null;

      let model = this.calcModelConfig(config);
      if (true)
        model.forEach((el) => {
          if (el.hiddenCreate && !this.data?.id) {
            el.hidden = true;
          }
        });
      this.fieldsF = getFields(config.fieldsForm).replace(" ", "").replace(/\s/g, "").split(",");

      //model = this.getFormModel(config.fieldsForm.replace(" ", "").replace(/\s/g, "").split(","), model);
      this.model = model;
      this.fillFormFromModel(model);
      this.inputData(this.initData);
      //   console.log("model", model);
    },
    calcPrice_m2() {
      this.data.price_m2 = "";
      if (this.data.ap_area && this.data.ap_price_buy) {
        this.data.price_m2 = (this.data.ap_price_buy / this.data.ap_area).toFixed(2);
      }
    },

    afterRemove(data) {
      this.removeDialogShow = false;
      this.$emit("input");
      this.$router.push({ name: this.typeObject });
    },
    async afterSave(data, status) {
      if (status) this.$emit("input");
    },
    afterFetchData(r) {
      let t = 0;
      if (this.m?.config.agentObjects?.watch) {
        t = this.data?.[this.m.config.agentObjects.watch] || 0;
      }
      console.log("aft", t);
      this.getModel(t);
      this.loaded = true;
    },
    inputData(d = {}) {
      if (this.id) return;
      if (d)
        for (let i = 0; i < this.model.length; i++) {
          let el = this.model[i];
          if (el?.hidden == true) {
          } else {
            if (!el.name.includes("data.")) {
              this.$set(this.data, el.name, d?.[el.name]);
            }
          }
        }
    },
  },
};
</script>
